import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  GetInvestorVoteSummary,
  IssAndglasslewis_vote,
  GetManager_voting_against,
  GetDissident_Data_for_Investor_v2,
  GetManager_latest_against2,
  GetInvestorVoteDisclosures,
} from '../../../utils/investor-util';

export const getInvestorVoteSummaryReq = createAsyncThunk('getInvestorVoteSummaryReq', async (investor_id) => {
  const response = await GetInvestorVoteSummary(investor_id);
  return response;
});

export const getInvestorVoteDisclosuresReq = createAsyncThunk('getInvestorVotDisclosuresReq', async (investor_id) => {
  const response = await GetInvestorVoteDisclosures(investor_id);
  return response;
});

export const issAndglasslewis_voteReq = createAsyncThunk('issAndglasslewis_voteReq', async (investor_id) => {
  const response = await IssAndglasslewis_vote(investor_id);
  return response;
});

export const getManager_voting_againstReq = createAsyncThunk('getManager_voting_againstReq', async (investor_id) => {
  const response = await GetManager_voting_against(investor_id);
  return response;
});

export const getDissident_Data_for_Investor_v2Req = createAsyncThunk(
  'getDissident_Data_for_Investor_v2Req',
  async (investor_id) => {
    const response = await GetDissident_Data_for_Investor_v2(investor_id);
    return response;
  },
);

export const getManager_latest_against2Req = createAsyncThunk('getManager_latest_against2Req', async (investor_id) => {
  const response = await GetManager_latest_against2(investor_id);
  return response;
});

const VotingOverviewSlice = createSlice({
  name: 'invVotingOverview',
  initialState: {
    isLoadingVotedManagerList: true,
    investorVoteSum: [],
    investorVoteDis: [],
    issAndglasslewis: [],
    manager_voting_against: [],
    dissDataforInvestor: [],
    managerLatestAgainst: [],
    isStartSearch: false,
  },
  reducers: {
    handleResetAll: {
      reducer(state) {
        state.isLoadingVotedManagerList = true;
        state.investorVoteSum = [];
        state.investorVoteDis = [];
        state.issAndglasslewis = [];
        state.manager_voting_against = [];
        state.manager_voting_against = [];
        state.manager_voting_against = [];
        state.dissDataforInvestor = [];
        state.managerLatestAgainst = [];
      },
      prepare() {
        return {};
      },
    },
    handleStartSearch: {
      reducer(state) {
        state.isStartSearch = true;
      },
      prepare() {
        return {
          payload: {},
        };
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvestorVoteSummaryReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.investorVoteSum = action.payload;
        }
      })
      .addCase(getInvestorVoteDisclosuresReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.investorVoteDis = action.payload;
        }
      })
      .addCase(issAndglasslewis_voteReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.issAndglasslewis = action.payload;
        }
      })
      .addCase(getManager_voting_againstReq.fulfilled, (state, action) => {
        if (action.payload) {
          state.manager_voting_against = action.payload;
        }
      })
      .addCase(getDissident_Data_for_Investor_v2Req.fulfilled, (state, action) => {
        if (action.payload) {
          state.dissDataforInvestor = action.payload;
        }
      })
      .addCase(getManager_latest_against2Req.fulfilled, (state, action) => {
        if (action.payload) {
          state.managerLatestAgainst = action.payload;
        }
        state.isLoadingVotedManagerList = action.payload === undefined;
      });
  },
});

export const { handleResetAll, handleStartSearch } = VotingOverviewSlice.actions;

export default VotingOverviewSlice.reducer;
